/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HeaderSectionGenerated } from './HeaderSectionGenerated';
import {
    HeaderSectionGeneratedFromJSON,
    HeaderSectionGeneratedFromJSONTyped,
    HeaderSectionGeneratedToJSON,
} from './HeaderSectionGenerated';
import type { HeaderSectionParameters } from './HeaderSectionParameters';
import {
    HeaderSectionParametersFromJSON,
    HeaderSectionParametersFromJSONTyped,
    HeaderSectionParametersToJSON,
} from './HeaderSectionParameters';

/**
 * 
 * @export
 * @interface HeaderSection
 */
export interface HeaderSection {
    /**
     * 
     * @type {string}
     * @memberof HeaderSection
     */
    type: HeaderSectionTypeEnum;
    /**
     * 
     * @type {HeaderSectionParameters}
     * @memberof HeaderSection
     */
    parameters: HeaderSectionParameters;
    /**
     * 
     * @type {HeaderSectionGenerated}
     * @memberof HeaderSection
     */
    generated: HeaderSectionGenerated;
}


/**
 * @export
 */
export const HeaderSectionTypeEnum = {
    Header: 'HEADER'
} as const;
export type HeaderSectionTypeEnum = typeof HeaderSectionTypeEnum[keyof typeof HeaderSectionTypeEnum];


/**
 * Check if a given object implements the HeaderSection interface.
 */
export function instanceOfHeaderSection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "parameters" in value;
    isInstance = isInstance && "generated" in value;

    return isInstance;
}

export function HeaderSectionFromJSON(json: any): HeaderSection {
    return HeaderSectionFromJSONTyped(json, false);
}

export function HeaderSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeaderSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'parameters': HeaderSectionParametersFromJSON(json['parameters']),
        'generated': HeaderSectionGeneratedFromJSON(json['generated']),
    };
}

export function HeaderSectionToJSON(value?: HeaderSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'parameters': HeaderSectionParametersToJSON(value.parameters),
        'generated': HeaderSectionGeneratedToJSON(value.generated),
    };
}

